import { CheckCircle2, Circle, Trophy, ArrowRight } from "lucide-react";

export default function Milestones({ milestones, onNavigate }) {
  const done = milestones.filter((m) => m.completed).length;
  return (
    <div data-testid="milestones-panel">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg text-white flex items-center gap-2"><Trophy className="w-5 h-5 text-[#D4AF37]" /> Milestones</h3>
        <span className="text-sm text-[#71717A]">{done} of {milestones.length} unlocked</span>
      </div>
      <div className="relative pl-6">
        <div className="absolute left-[9px] top-2 bottom-2 w-px bg-white/10" />
        <div className="space-y-2.5">
          {milestones.map((m) => (
            <div key={m.id} data-testid={`milestone-${m.id}`}
              className={`relative rounded-xl border p-4 ${m.completed ? "border-[#D4AF37]/30 bg-[#151310]" : "border-white/8 bg-[#121214]"}`}>
              <span className="absolute -left-[22px] top-4 bg-[#0A0A0B] rounded-full">
                {m.completed ? <CheckCircle2 className="w-[18px] h-[18px] text-[#D4AF37]" /> : <Circle className="w-[18px] h-[18px] text-[#52525B]" />}
              </span>
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className={`text-sm font-medium ${m.completed ? "text-white" : "text-[#A1A1AA]"}`}>{m.label}</div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${m.completed ? "bg-[#D4AF37]/15 text-[#D4AF37]" : "bg-white/8 text-[#71717A]"}`}>{m.status}</span>
                    <span className="text-[11px] text-[#52525B] capitalize">{m.workflow}</span>
                    {m.completed && <span className="text-[10px] text-emerald-300/80">🏆 Achievement unlocked</span>}
                  </div>
                  {!m.completed && m.next && <p className="text-[11px] text-[#52525B] mt-1">Next: {m.next}</p>}
                </div>
                {!m.completed && (
                  <button onClick={() => onNavigate(m.route)} data-testid={`milestone-go-${m.id}`}
                    className="shrink-0 text-xs text-[#D4AF37] hover:underline flex items-center gap-1">Work on it <ArrowRight className="w-3 h-3" /></button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
